import { PermissionsEnum } from "@/auth/interfaces";
import {
  ROUTER_PATHS, handleErrorForm, hasPermission, gridSizeMdLg12, SegmentacionENUM,
  texto, gridSizeMdLg6,
  TipoIdentificacionEnumChoice,
  formatDate
} from "@/shared";
import {
  SingleTableBoxScene, TabTextLabel, CustomAutocompleteArrString, CustomTextFieldNumberComponente,
  CustomTextField,
  SampleDatePicker,
  CustomAutocomplete
} from "@/shared/components/ui";
import { CustomAlertCard } from "@/shared/components/ui/Alerts";
import { TiposTextFieldNumberEnum } from "@/shared/components/ui/CustomTextFieldNumberComponente";
import { AlertSeverityEnum, ErrorMessagesForm, Pais, RangoEdadEnum, TipoDocumentoNameEnum, TipoPlanCorporativo } from "@/shared/interfaces";
import { Grid, Alert, AlertTitle } from "@mui/material";
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import { useFormProspectoPymes } from "../../hook/useFormProspectoPymes";
import CustomIdentificationSearch from "@/shared/components/ui/CustomIdentificationSearch/CustomIdentificationSearch";
import CondicionVentaPymes from "../condicion_venta_pymes/CondicionVentaPymes";

const ESTADO_CONTRIBUYENTE_RUC = ['ACTIVO', 'SUSPENDIDO']
const TIPO_CONTRIBUYENTE_RUC = ['SOCIEDAD', 'PERSONA NATURAL']
const REGIMEN_RUC = ['RIMPE', 'GENERAL']

interface SaveProspectoPymesPropsPymes {
  titulo: string
}

export default function SaveProspectoPymes({
  titulo
}: SaveProspectoPymesPropsPymes) {


  const {
    //state
    esCliente,
    setEsCliente,
    setDisableIdentification,
    disableIdentification,
    dataPais,
    isLoadingPais,
    calcularEdad,
    setAlert,
    //
    form,
    control,
    reset,
    errors,
    setError,
    onSubmit,
    fnBuscarIdentificacion,
    //dataProspectoEnEspera,
    handleBuscarIdentificacion,
    valorRestriccionCel
  } = useFormProspectoPymes();


  return (
    <>
      <SingleTableBoxScene
        py={1}
        title={titulo}
        iconRedirect={<FormatListBulletedIcon />}
        enableRedirect={true}
        textRedirect='Prospectos'
        textCreateOrEditBtn='Guardar'
        urlRedirect={ROUTER_PATHS.ventasPymes.prospectoNav}
        visibleReport={false}
        fnCreateOrEdit={form.handleSubmit(onSubmit, (error) => {
          handleErrorForm(error as ErrorMessagesForm);
        })}

        enableCreateOrEditBtn={hasPermission(PermissionsEnum.api_add_prospecto)}
      >

        <Grid container spacing={3}>

          {
            form.getValues().segmentacion === SegmentacionENUM.NO_DATA && (
              <CustomAlertCard
                alertColor='info'
                alertTitle="Nota"
                alertMessage={texto.no_informacion_equifax} />
            )
          }

          {
            esCliente.alerta && (
              <Grid item {...gridSizeMdLg12}>
                <Alert severity="info" onClose={() => { setEsCliente({ ...esCliente, alerta: false }) }}>
                  <AlertTitle>Información</AlertTitle>
                  <Grid container>
                    <Grid item xs={12}>
                      <span>{`El cliente ${esCliente.nombre} forma parte de FibraMax.`} </span>
                    </Grid>
                  </Grid>
                </Alert>
              </Grid>
            )
          }

          <Grid item   {...gridSizeMdLg6}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <TabTextLabel text={texto.informacion_personal} mt={0} pb={2} pl={0} pt={0} />
              </Grid>
              <CustomAutocompleteArrString
                size={gridSizeMdLg6}
                label={texto.tipo_documento}
                name="tipo_identificacion"
                options={[TipoIdentificacionEnumChoice.RUC]}
                defaultValue={form.getValues().tipo_identificacion || TipoIdentificacionEnumChoice.RUC}
                isLoadingData={false}
                control={control}
                error={errors.tipo_identificacion}
                helperText={errors.tipo_identificacion?.message}
                onChangeValue={(e) => {

                  reset({ tipo_identificacion: e });
                  setEsCliente({ alerta: false, linea: undefined, nombre: '', plan: '' });
                  if (e == TipoDocumentoNameEnum.CEDULA || e == TipoDocumentoNameEnum.RUC) {
                    reset({ tipo_identificacion: form.getValues().tipo_identificacion });
                    setDisableIdentification(false);
                    return;
                  }
                  setDisableIdentification(true);

                }}
              />

              <CustomIdentificationSearch
                form={form}
                disabled={disableIdentification}
                max={form.getValues().tipo_identificacion == TipoDocumentoNameEnum.CEDULA ? 10 : 13}
                onChangeValue={aux => handleBuscarIdentificacion(aux)}
                name="identificacion"
                defaultValue={form.getValues().identificacion || ''}
                onClickSearch={() => {
                  if (form.getValues().identificacion && form.getValues().identificacion.length === 13)
                    return handleBuscarIdentificacion(form.getValues().identificacion || '')
                  setError('identificacion', { message: 'Campo Obligatorio' })
                }}
              />


              {form.getValues().tipo_identificacion === TipoDocumentoNameEnum.CEDULA && (
                <>

                  <CustomTextField
                    control={control}
                    name="razon_social"
                    type="texto_sin_numeros"
                    defaultValue={form.getValues().razon_social}
                    size={gridSizeMdLg12}
                    label={'Razón social'}
                    error={errors.razon_social}
                    helperText={errors.razon_social?.message} />

                  <SampleDatePicker
                    //minDate={subtractHundredYears()}
                    maxDate={formatDate(new Date)}
                    label={texto.fecha_nacimiento}
                    control={control}
                    error={errors.fecha_nacimiento}
                    helperText={errors.fecha_nacimiento?.message}
                    name="fecha_nacimiento"
                    textFieldKey={'fecha_nacimiento'}
                    size={gridSizeMdLg6}
                    defaultValue={form.getValues().fecha_nacimiento ?? ''}
                    onChangeValue={(e) => {
                      let edad = calcularEdad(e);
                      edad >= RangoEdadEnum.EDAD_MAXIMA && setAlert(true, texto.persona_tercera_edad, AlertSeverityEnum.info)
                      form.setValue('edad', edad)
                    }}
                  />

                  <CustomTextField
                    disabled={true}
                    control={control}
                    name="edad"
                    defaultValue={form.getValues().edad}
                    size={gridSizeMdLg6}
                    label={texto.edad}
                    error={errors.edad}
                    helperText={errors.edad?.message} />


                  <CustomAutocomplete<Pais>
                    size={gridSizeMdLg6}
                    label={texto.nacionalidad}
                    name="nacionalidad"
                    options={dataPais || []}
                    valueKey="nacionalidad"
                    actualValueKey="codigo"
                    defaultValue={form.getValues().nacionalidad}
                    isLoadingData={isLoadingPais}
                    control={control}
                    error={errors.nacionalidad}
                    helperText={errors.nacionalidad?.message}
                  />

                  <CustomAutocomplete<Pais>
                    size={gridSizeMdLg6}
                    label={texto.pais}
                    name="pais"
                    options={dataPais || []}
                    valueKey="nombre"
                    actualValueKey="codigo"
                    defaultValue={form.getValues().pais}
                    isLoadingData={isLoadingPais}
                    control={control}
                    error={errors.pais}
                    helperText={errors.pais?.message}
                  />



                </>
              )
              }

              {form.getValues().tipo_identificacion === TipoDocumentoNameEnum.RUC && (
                <>
                  <CustomTextField
                    disabled={false}
                    control={control}
                    name="razon_social"
                    type="texto_sin_numeros"
                    defaultValue={form.getValues().razon_social}
                    size={gridSizeMdLg12}
                    label={'Razon Social'}
                    error={errors.razon_social}
                    helperText={errors.razon_social?.message} />

                  <CustomAutocompleteArrString
                    label="Tipo contribuyente"
                    name="tipo_contribuyente"
                    options={TIPO_CONTRIBUYENTE_RUC}
                    control={form.control}
                    defaultValue={form.getValues().tipo_contribuyente || ''}
                    error={errors.tipo_contribuyente}
                    helperText={errors.tipo_contribuyente?.message?.toString() ?? ''}
                    isLoadingData={false}
                    size={gridSizeMdLg12}
                  />

                  <CustomAutocompleteArrString
                    label="Estado Contribuyente"
                    name="estado_contribuyente_ruc"
                    options={ESTADO_CONTRIBUYENTE_RUC}
                    control={form.control}
                    defaultValue={form.getValues().estado_contribuyente_ruc || ''}
                    error={errors.estado_contribuyente_ruc}
                    helperText={errors.estado_contribuyente_ruc?.message?.toString() ?? ''}
                    isLoadingData={false}
                    size={gridSizeMdLg6}
                  />

                  <CustomAutocompleteArrString
                    label="Regimen"
                    name="regimen"
                    options={REGIMEN_RUC}
                    control={form.control}
                    defaultValue={form.getValues().regimen || ''}
                    error={errors.regimen}
                    helperText={errors.regimen?.message?.toString() ?? ''}
                    isLoadingData={false}
                    size={gridSizeMdLg6}
                  />

                  <CustomTextField
                    disabled={false}
                    control={control}
                    name="actividad_economica_principal"
                    type="texto_sin_numeros"
                    defaultValue={form.getValues().actividad_economica_principal}
                    size={gridSizeMdLg12}
                    label={'Actividad Economica Principal'}
                    error={errors.actividad_economica_principal}
                    helperText={errors.actividad_economica_principal?.message} />
                </>
              )}


            </Grid>

          </Grid>

          <Grid item {...gridSizeMdLg6}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <TabTextLabel text={texto.informacion_equifax} mt={0} pb={2} pl={0} pt={0} />
              </Grid>


              <CustomTextField
                disabled={true}
                control={control}
                name="puntaje_score"
                defaultValue={form.getValues().puntaje_score || ''}
                size={gridSizeMdLg12}
                label={texto.puntaje_score}
                error={errors.puntaje_score}
                helperText={errors.puntaje_score?.message} />

              <CustomTextField
                disabled={true}
                control={control}
                name="puntaje_score_sobreendeudamiento"
                defaultValue={form.getValues().puntaje_score_sobreendeudamiento || ''}
                size={gridSizeMdLg12}
                label={texto.puntaje_score_sobreendeudamiento}
                error={errors.puntaje_score_sobreendeudamiento}
                helperText={errors.puntaje_score_sobreendeudamiento?.message} />

              <CustomTextField
                disabled={true}
                control={control}
                name="puntaje_score_empresa"
                defaultValue={form.getValues().puntaje_score_empresa || ''}
                size={gridSizeMdLg12}
                label={texto.puntaje_score_empresa}
                error={errors.puntaje_score_empresa}
                helperText={errors.puntaje_score_empresa?.message} />

              <CustomTextField
                disabled={true}
                control={control}
                name="segmentacion"
                defaultValue={form.getValues().segmentacion || ''}
                size={gridSizeMdLg12}

                label={texto.segmentacion}
                error={errors.segmentacion}
                helperText={errors.segmentacion?.message} />

              <CustomTextFieldNumberComponente
                size={gridSizeMdLg12}
                type={TiposTextFieldNumberEnum.CELULAR}
                label={texto.celular}
                error={errors.celular}
                helperText={errors.celular?.message}
                control={control}
                name="celular"
                defaultValue={form.getValues().celular || ''}
                customRestriccionCelular={valorRestriccionCel}
              />

            </Grid>
          </Grid>


          <Grid item xs={12}>
            <TabTextLabel text={'Evento/Canje'} mt={0} pb={0} pl={0} pt={0} />
          </Grid>

          <Grid item {...gridSizeMdLg12}>
            <CondicionVentaPymes
              form={form}
              servicio={TipoPlanCorporativo.PYME}
              handleDataSolicitud={(data) => {
                handleBuscarIdentificacion(data.identificacion)
              }}
            />

          </Grid>

        </Grid>
      </SingleTableBoxScene>




    </>
  );

}